import { render } from "./Timetable.vue?vue&type=template&id=c4b4e0fa&scoped=true"
import script from "./Timetable.vue?vue&type=script&lang=js"
export * from "./Timetable.vue?vue&type=script&lang=js"

import "./Timetable.vue?vue&type=style&index=0&id=c4b4e0fa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4b4e0fa"]])

export default __exports__